import { render, staticRenderFns } from "./Computed.vue?vue&type=template&id=1d35543b&scoped=true"
import script from "./Computed.vue?vue&type=script&lang=js"
export * from "./Computed.vue?vue&type=script&lang=js"
import style0 from "./Computed.vue?vue&type=style&index=0&id=1d35543b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d35543b",
  null
  
)

export default component.exports